import React, { useLayoutEffect, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { Link } from "react-router-dom";
import { urlFor } from "../../client";

function HomeBlogCard({ blog }) {

  const docu = window.screen.width

  const number = () =>{
    if(docu>800){
      return 3
    }
    else{
      return 1
    }
  }

  return (
    <Swiper
      slidesPerView={number()} 
      spaceBetween={40}
      onSwiper={(swiper) => console.log(swiper)}
      loop
      speed={3000}
      modules={[Autoplay, Navigation]}
      // navigation={true}
      autoplay={{ delay: 1000 }}
    >
      {blog.slice(0, 9)?.map((blog, index) => {
        const { title, slug, mainImage, _id, publishedAt, author } = blog;
        return (
          <>
            {mainImage && (
              <SwiperSlide key={index} style={{ width: "50%" }}>
                <Link
                  to={`/blog/${slug.current}`}
                  style={{ textDecoration: "none" }}
                >
                  {mainImage && mainImage.asset && (
                    <div
                      className="Blog__card h-[350px] p-[20px] flex items-end rounded-[20px] w-full shadow-2xl"
                      key={_id}
                      style={{
                        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.4) 60%, rgba(0, 0, 0, 0.4)60%), url(${urlFor(
                          mainImage.asset
                        ).url()})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <div>
                        <span className="flex items-center gap-x-[8px]">
                          {" "}
                          {publishedAt && (
                            <span className="text-gray-300 font-semibold text-[13px] items-start leading-[15px]">
                              {new Date(publishedAt).toLocaleDateString(
                                "en-US",
                                {
                                  dateStyle: "long",
                                }
                              )}
                            </span>
                          )}
                          {/* <span>.</span> */}
                          <div className="relative  flex items-center gap-x-[4px]">
                            {author?.image && (
                              <img
                                src={urlFor(author?.image)?.url()}
                                alt={title}
                                className="h-[20px] w-[20px] rounded-full bg-gray-50"
                              />
                            )}
                            <div>
                              <p className="font-semibold text-[13px]">
                                <a
                                  href="#"
                                  className="no-underline text-gray-300 font-semibold"
                                >
                                  <span className="absolute inset-0" />
                                  {author?.name}
                                </a>
                              </p>
                            </div>
                          </div>
                        </span>
                        <div >
                          {title && <p className="text-[16px] font-bold text-white">{title}</p>}
                        </div>
                      </div>
                    </div>
                  )}
                </Link>
              </SwiperSlide>
            )}
          </>
        );
      })}
    </Swiper>
  );
}

export default HomeBlogCard;
